import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import styles from 'assets/jss/material-dashboard-pro-react/views/Apps/addressValidationStyle'
const useStyles = makeStyles(styles)

export function FieldsDetailsModal(props) {
  const classes = useStyles()
  const { showModal, modalInfo, onClose } = props

  return (
    <Dialog
      classes={{
        root: classes.center + ' ' + classes.modalRoot
      }}
      open={showModal}
      fullWidth={true}
      maxWidth={'md'}
      onClose={() => onClose()}
    >
      <DialogTitle>Other fields found</DialogTitle>
      <DialogContent className={classes.modalBody}>
        {typeof modalInfo === 'object' ? (
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Key</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modalInfo && modalInfo.length > 0 ? (
                modalInfo.map((info, i) => (
                  <TableRow key={i}>
                    <TableCell>{info.key ?? ''}</TableCell>
                    <TableCell>{info.value ?? ''}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>No information</TableRow>
              )}
            </TableBody>
          </Table>
        ) : (
          'No information to show'
        )}
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button onClick={() => onClose()} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
